import { Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Input, InputAuto, Select } from "../../../controls";
import { AppContext } from "../../../App";
import { action, API, controller } from "../../../api/api";
import { Dialog } from "../../../layout";
import AddEditGroup from "../Group/AddEditGroup";
import { DropLi } from "../../../hooks";

const GeneralFields = ({ values, setValues, errors, handleInpChg }) => {
  const { AccBalTypes } = DropLi();
  const [groups, setGroups] = useState([]);
  const { authUser } = useContext(AppContext);

  const [newAddingValue, setNewAddingValue] = useState("");
  const [showGroupForm, setShowGroupForm] = useState(false);

  useEffect(() => {
    if (authUser) {
      API(controller.CstmrGroup + action.GetAllByOrg).get((res) => {
        res &&
          res.status === 200 &&
          setGroups([...res.result.map((j) => ({ ...j, label: j.name }))]);
      });
    }

    return () => {};
  }, [authUser]);

  const handleAddNewGroup = (val) => {
    setNewAddingValue(val);
    setShowGroupForm(!showGroupForm);
  };
  const handleNewGroup = (val) => {
    if (val) {
      setGroups([{ ...val, label: val.name }, ...groups]);
      setValues((j) => ({ ...j, cstmrGroupId: val.id }));
      setNewAddingValue("");
    }
  };

  return values && errors ? (
    <>
      {" "}
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Input
            label="First Name"
            name="firstName"
            required={true}
            value={values.firstName}
            error={errors.firstName}
            inputProps={{ maxLength: 255 }}
            onChange={handleInpChg}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Input
            label="Last Name"
            name="lastName"
            required={true}
            value={values.lastName}
            error={errors.lastName}
            inputProps={{ maxLength: 255 }}
            onChange={handleInpChg}
          />
        </Grid>
        <Grid item xs={12} md={3.5}>
          <Input
            label="Email"
            name="email"
            value={values.email}
            inputProps={{ maxLength: 200 }}
            onChange={handleInpChg}
          />
        </Grid>
        {!values.id && (
          <Grid item xs={12} md={2.5}>
            <Input
              label="Opening Blanace"
              name="openingBalance"
              placeholder="$ 0.000"
              value={values.openingBalance}
              error={errors.openingBalance}
              type="number"
              onChange={handleInpChg}
            />
          </Grid>
        )}
        <Grid item xs={12} md={3.5}>
          <Input
            label="Phone"
            name="phone"
            value={values.phone}
            inputProps={{ maxLength: 50 }}
            onChange={handleInpChg}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InputAuto
            label="Customer Group"
            name="cstmrGroupId"
            value={values.cstmrGroupId}
            error={errors.cstmrGroupId}
            onChange={handleInpChg}
            options={groups}
            enableAddBtn={true}
            handleAdd={handleAddNewGroup}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Select
            label="Allow an on account balance"
            name="accBalType"
            value={values.accBalType}
            onChange={handleInpChg}
            options={AccBalTypes}
          />
        </Grid>
        <Grid item xs={12} md={2.5}>
          <Input
            label="Balance Limit"
            name="balLimit"
            value={values.balLimit}
            placeholder="$ 0.00"
            type="number"
            onChange={handleInpChg}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            label="Note"
            name="note"
            value={values.note}
            multiline
            rows={3}
            inputProps={{ maxLength: 1000 }}
            onChange={handleInpChg}
          />
        </Grid>
      </Grid>
      {/* Add new group */}
      {showGroupForm && (
        <Dialog show={showGroupForm} onClose={false} maxWidth="xs">
          <AddEditGroup
            {...{
              setShowForm: setShowGroupForm,
              openFromOtherSide: true,
              groupName: newAddingValue,
              handleResult: handleNewGroup,
            }}
          />
        </Dialog>
      )}
    </>
  ) : (
    <span>Loading..</span>
  );
};

export default GeneralFields;
